import io from "socket.io-client";
import {
  trackingConnected,
  trackingDisconnected,
  trackingEnded,
  snapshotReceived,
  dropoffReceived,
  driverLocationReceived,
  storeEta15Received,
  milestoneReceived,
  orderUpdateReceived,
  driverStalledReceived,
} from "../slices/orderTrackingSlices";



const SOCKET_ORIGIN =
  process.env.REACT_APP_SOCKET_ORIGIN || "http://localhost:5001"; // use https://... if server is https

export function createOrderSocket({ token, orderId }) {
  const socket = io(SOCKET_ORIGIN, {
    path: "/rt",
    transports: ["websocket"],
    withCredentials: true,
    auth: { token },
  });

  socket.on("connect", () => {
    socket.emit("join_order", { orderId });
  });
  socket.on("connect_error", (err) => console.error("[sock] connect_error", err));
  socket.on("disconnect", (r) => console.warn("[sock] disconnect", r));
  return socket;
}


// Bind socket events to Redux for one order
export function bindOrderSocket(dispatch, socket, orderId) {
  const onConnect = () => dispatch(trackingConnected({ orderId }));
  const onDisconnect = () => dispatch(trackingDisconnected({ orderId }));
  const onSnapshot = (p) => dispatch(snapshotReceived({ orderId, dropoff: p?.dropoff, driverStatus: p?.driverStatus }));
  const onDriver = (l) => dispatch(driverLocationReceived({ orderId, ...l }));
  const onDropoff = (l) => l?.lat && l?.lng && dispatch(dropoffReceived({ orderId, lat: l.lat, lng: l.lng }));
  const onEta = (e) => dispatch(storeEta15Received({ orderId, etaMinutes: e?.etaMinutes, ts: e?.ts }));
  const onMilestone = (e) => dispatch(milestoneReceived({ orderId, type: e.type, ts: e.ts, source: e.source }));
  const onUpdate = (chg) => dispatch(orderUpdateReceived({ orderId, change: chg }));
  const onEnd = (e) => dispatch(trackingEnded({ orderId, ts: e?.ts }));
  const onStalled = (e) => dispatch(driverStalledReceived({ orderId, ...e }));

  socket.on("connect", onConnect);
  socket.on("disconnect", onDisconnect);
  socket.on("order:snapshot", onSnapshot);
  socket.on("driver:location", onDriver);
  socket.on("order:dropoff", onDropoff);
  socket.on("order:store_eta_15", onEta);
  socket.on("order:milestone", onMilestone);
  socket.on("order:update", onUpdate);
  socket.on("order:tracking_end", onEnd);
  socket.on("order:driver_stalled", onStalled);

  // Unbinder
  return () => {
    socket.off("connect", onConnect);
    socket.off("disconnect", onDisconnect);
    socket.off("order:snapshot", onSnapshot);
    socket.off("driver:location", onDriver);
    socket.off("order:dropoff", onDropoff);
    socket.off("order:store_eta_15", onEta);
    socket.off("order:milestone", onMilestone);
    socket.off("order:update", onUpdate);
    socket.off("order:tracking_end", onEnd);
    socket.off("order:driver_stalled", onStalled);
  };
}
